export const REASON_KEYS = {
  // PinFlagReasons: pinboard/core/enums.py:160
  SPAM: 'spam',
  PORN: 'nudity',
  SELF_INJURY: 'self-harm',
  HATE_SPEECH: 'hate-speech',
  DANGEROUS_GOODS: 'dangerous-goods',
  HARASSMENT: 'attacks',
  VIOLENCE: 'graphic-violence',
  MEDICAL_MISINFORMATION: 'medical-misinformation',
  // PromotedPinFlagReasons: pinboard/core/enums.py:193
  MISLEADING: 'misleading-promoted',
  OFFENSIVE: 'offensive-promoted',
  LOW_QUALITY: 'low-quality-promoted',
  INTELLECTUAL_PROPERTY: 'intellectualProperty',
  // Product pin reasons
  PRODUCT_OFFENSIVE: 'offensive-product',
  PRODUCT_MISLEADING: 'misleading-product',
  PRODUCT_PROHIBITED: 'prohibited-product',
  PRODUCT_MATURE: 'mature-product',
  PRODUCT_WEAPONS: 'weapons-product',
  PRODUCT_RESTRICTED_HEALTHCARE: 'restricted-healthcare-product',
};

export const ReasonToThriftElementType = {
  spam: PCONST.thrift.ElementType.SPAM,
  nudity: PCONST.thrift.ElementType.NUDITY,
  'self-harm': PCONST.thrift.ElementType.SELF_INJURY,
  'hate-speech': PCONST.thrift.ElementType.HATE_SPEECH,
  'dangerous-goods': PCONST.thrift.ElementType.DANGEROUS_GOODS,
  attacks: PCONST.thrift.ElementType.HARASSMENT,
  'graphic-violence': PCONST.thrift.ElementType.VIOLENCE,
  'medical-misinformation': PCONST.thrift.ElementType.MEDICAL_MISINFORMATION,
  intellectualProperty: PCONST.thrift.ElementType.INTELLECTUAL_PROP,
  'low-quality-promoted': PCONST.thrift.ElementType.PROMOTED_LOW_QUALITY,
  'misleading-promoted': PCONST.thrift.ElementType.PROMOTED_MISLEADING,
  'offensive-promoted': PCONST.thrift.ElementType.PROMOTED_OFFENSIVE,
  'offensive-product': PCONST.thrift.ElementType.PRODUCT_OFFENSIVE,
  'misleading-product': PCONST.thrift.ElementType.PRODUCT_MISLEADING,
  'prohibited-product': PCONST.thrift.ElementType.PRODUCT_PROHIBITED,
  'mature-product': PCONST.thrift.ElementType.PRODUCT_MATURE,
  'weapons-product': PCONST.thrift.ElementType.PRODUCT_WEAPONS,
  'restricted-healthcare-product': PCONST.thrift.ElementType.PRODUCT_RESTRICTED_HEALTHCARE,
};

export default REASON_KEYS;
